import { Box } from '~/commonComponents';
import { EmptyScreen } from '~/commonComponents/EmptyScreen/EmptyScreen';

import EmptyReferralIcon from '~/images/referral/referral-empty.svg';
import { shouldUseReferralProgramV2 } from '~/growthbook';

export const EmptyReferral = () => {
  return (
    <Box>
      <EmptyScreen
        Icon={() => <img src={EmptyReferralIcon} alt="icon" style={{ width: 172, height: 171 }} />}
        title={'No referrals yet!'}
        description={
          shouldUseReferralProgramV2()
            ? 'Invite your friends using the link above! Once your invites are on the way, you’ll be able to follow their progress and track their status here.'
            : 'Start inviting your friends above! Once your invites are on the way, you’ll see their status listed down here.'
        }
      />
    </Box>
  );
};
